import { type TFunction } from 'i18next';
import {
  type BooleanSchema,
  type NumberSchema,
  object,
  type ObjectSchema,
  type StringSchema,
} from 'yup';

type Schema<T extends TYPE> = T extends string
  ? StringSchema
  : T extends number
    ? NumberSchema
    : T extends boolean
      ? BooleanSchema
      : never;

type TYPE = boolean | number | string;

export const selectSearchOptionOptionalValidation = <T extends TYPE>(
  schema: Schema<T>,
): ObjectSchema<{ label?: string; value?: T }> =>
  // @ts-expect-error: fix later
  object().shape({
    value: schema.optional(),
  });

export const selectSearchOptionRequiredFieldsValidation = <T extends TYPE>(
  schema: Schema<T>,
  t: TFunction,
): ObjectSchema<{ label: string; value: T }> => {
  // @ts-expect-error: fix later
  return object().shape({
    value: schema.required(t('general.required')),
  });
};

export const selectSearchOptionRequiredValidation = <T extends TYPE>(
  schema: Schema<T>,
  t: TFunction,
): ObjectSchema<{ label: string; value: T }> => {
  // @ts-expect-error: fix later
  return object()
    .shape({
      value: schema.required(t('general.required')),
    })
    .required(t('general.required'));
};
